import * as React from "react";
import { Button, Grid, Paper, Typography } from "@material-ui/core";
import ICommunityConfig from "../types/ICommunityConfig";

interface IProps {
  communityConfig: ICommunityConfig | undefined,
  classes: any
}

class RequestMembershipConfirmation extends React.Component<IProps, {}>{
  
  public render(){
    const {classes, communityConfig } = this.props;
    
    return <Grid direction='column' container className={classes.container}>
      {communityConfig && communityConfig.logoUrl &&
        <Grid item>
          <img
            src={communityConfig.logoUrl}
            className={this.props.classes.logo}
          />
        </Grid>}

      <Grid item>
        <Typography variant="title">
          Membership requested
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          {communityConfig ? communityConfig.name : null}
        </Typography>
      </Grid>

      <Grid item className={classes.paper}>
        <Paper className="padding-24">
          <Typography gutterBottom={true}>
            Your community membership has been requested.
          </Typography>
          <Typography gutterBottom={true} className="padding-bottom-24">
            You will receive an email once the community admin has approved your registration.
          </Typography>
          <Grid container={true} spacing={24} alignItems='center'>
            <Grid item={true}>
              <Button
                variant="outlined"
                color="secondary"
                href= {communityConfig ? communityConfig.returnUrl : ''}
              >
                Community page
              </Button>
            </Grid>
            <Grid item={true}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => location.replace(process.env.REACT_APP_APPLICATION_ROOT as string + 'organization/community-membership')}
              >
                View my request
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  }
}

export default RequestMembershipConfirmation;


// WEBPACK FOOTER //
// ./src/modules/communities/components/RequestMembershipConfirmation.tsx